import { boolean, int, json, mysqlTable, timestamp, varchar } from "drizzle-orm/mysql-core";
import type { z } from "zod";
import type { reachoutRequest } from "../shared/reachout";

export const reachoutInvitations = mysqlTable("reachout_invitations", {
  id: varchar("id", { length: 36 }).primaryKey(),
  inputHash: varchar("inputHash", { length: 64 }).notNull(),
  tokenHash: varchar("tokenHash", { length: 64 }).notNull(),
  contactHash: varchar("contactHash", { length: 64 }).notNull(),
  snapshot: json("snapshot").$type<z.output<typeof reachoutRequest>>().notNull(),
  test: boolean("test").notNull(),
  expiresAt: timestamp("expiresAt").notNull(),
  acceptedAt: timestamp("acceptedAt"),
  customerId: int("customerId"),
  interest: boolean("interest"),
  updates: boolean("updates"),
  updatesEmail: varchar("updatesEmail", { length: 320 }),
  consentVersion: varchar("consentVersion", { length: 40 }),
  invitationDelivery: varchar("invitationDelivery", { length: 24 }).notNull().default("pending"),
  reminderDelivery: varchar("reminderDelivery", { length: 24 }).notNull().default("none"),
  cardDelivery: varchar("cardDelivery", { length: 24 }).notNull().default("none"),
  adminDelivery: varchar("adminDelivery", { length: 24 }).notNull().default("none"),
  picDelivery: varchar("picDelivery", { length: 24 }).notNull().default("none"),
  picEmail: varchar("picEmail", { length: 320 }),
  createdAt: timestamp("createdAt").notNull().defaultNow(),
  updatedAt: timestamp("updatedAt").notNull().defaultNow().onUpdateNow(),
});
export const reachoutLimits = mysqlTable("reachout_limits", {
  key: varchar("key", { length: 100 }).primaryKey(),
  count: int("count").notNull().default(0),
});
